<app-svg-icon
  *ngIf="dataLayerType.icon"
  [key]="dataLayerType.icon"></app-svg-icon>
<i
  *ngIf="!dataLayerType.icon"
  [class]="
    dataLayerType.type === 'Polygon'
      ? 'fa-regular fa-map'
      : 'fas fa-location-dot'
  "></i>
